// extracted by mini-css-extract-plugin
export default {"banner-list-item-link":"BannerLink_banner-list-item-link__WBAOa"};